/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserClaimModel
 */
export interface UserClaimModel {
    /**
     * 
     * @type {string}
     * @memberof UserClaimModel
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof UserClaimModel
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserClaimModel
     */
    clientId?: string | null;
}

/**
 * Check if a given object implements the UserClaimModel interface.
 */
export function instanceOfUserClaimModel(value: object): value is UserClaimModel {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function UserClaimModelFromJSON(json: any): UserClaimModel {
    return UserClaimModelFromJSONTyped(json, false);
}

export function UserClaimModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserClaimModel {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'value': json['value'] == null ? undefined : json['value'],
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
    };
}

export function UserClaimModelToJSON(json: any): UserClaimModel {
    return UserClaimModelToJSONTyped(json, false);
}

export function UserClaimModelToJSONTyped(value?: UserClaimModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'value': value['value'],
        'clientId': value['clientId'],
    };
}

